<template>
  <li>
    <PopoverComp ref="popover">
      <template #button>
        <a class="dropdown-toggle text-reset py-2" href="javascript:void(0)">
          <slot
            :data="list.find((item) => item[idKey] === selectedItemId) || list[0]"
            name="button"
          />
        </a>
      </template>
      <template #popover>
        <ul :class="menuClassObj" class="dropdown-menu show">
          <li v-for="data in list" :key="data[idKey]" @click="select(data)">
            <slot
              :data="data"
              :isSelected="data[idKey] === selectedItemId"
              name="item"
            />
          </li>
        </ul>
      </template>
    </PopoverComp>
  </li>
</template>
<script>
import PopoverComp from "@/components/PopoverComp.vue";

export default {
  components: { PopoverComp },
  props: {
    idKey: { type: String, default: 'id' },
    alignRight: Boolean,
    list: Array,
    selectedId: String,
  },
  data() {
    return {
      selectedItemId: this.selectedId,
    };
  },
  methods: {
    select(itemData) {
      this.selectedItemId = itemData[this.idKey];
      this.$emit("select", itemData);
      this.$refs.popover.hide();
    },
  },
  computed: {
    menuClassObj() {
      return {
        "dropdown-menu-right": this.alignRight,
        "dropdown-menu-lg-left": this.alignRight,
        "dropdown-menu-left": !this.alignRight,
      };
    },
  },
};
</script>
